<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card v-if="profile" :fullWidth="true" min-width="380px" min-height="600px">
      <v-avatar slot="offset" class="mx-auto d-block" size="130">
        <img :src="profile.picture" />
      </v-avatar>
      <v-card-text class="text-xs-left">
        <h4>User profile</h4>
        <h6 class="category font-weight-thin mb-3">
          Email: {{ profile.email }}
        </h6>
        <h6 class="card-title font-weight-light">Name: {{ profile.name }}</h6>
        <v-btn color="primary" size="sm" class="mb-2" @click="setShowTechnicalDetails(!showTechnicalDetails)">{{technicalDetailsButtonLabel}}</v-btn>
      </v-card-text>
      <div v-if="showTechnicalDetails">
        <v-card-text>
          <h4>Raw</h4>
          <pre style="overflow-x: auto;" class="rounded"><code class="json">{{ JSON.stringify(profile, null, 2) }}</code></pre>
        </v-card-text>
        <v-card-text class="text-xs-left">
          <h4>ID token</h4>
          <pre style="overflow-x: auto;" class="rounded"><code class="json">{{ JSON.stringify(idToken, null, 2) }}</code></pre>
        </v-card-text>
        <v-card-text class="text-xs-left">
          <h4>Access token</h4>
          <pre style="overflow-x: auto;" class="rounded"><code class="json">{{ JSON.stringify(accessToken, null, 2) }}</code></pre>
        </v-card-text>
        <v-card-text class="text-xs-left">
          <h4>Jig tenants</h4>
          <pre style="overflow-x: auto;" class="rounded"><code class="json">{{ JSON.stringify(tenants, null, 2) }}</code></pre>
        </v-card-text>
        <v-card-text class="text-xs-left">
          <h4>Jig user ID</h4>
          <pre style="overflow-x: auto;" class="rounded"><code class="json">{{ JSON.stringify(uid, null, 2) }}</code></pre>
        </v-card-text>
      </div>
    </material-card>
    <material-card v-if="!profile">
      <v-card-text class="text-xs-center">
        <p>
          Please log in to see profile data.
        </p>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      profile: this.$auth.profile,
      accessToken: this.$auth.accessToken,
      tenants: this.$auth.tenants,
      uid: this.$auth.uid,
      idToken: this.$auth.idToken,
      showTechnicalDetails: false,
    };
  },
  methods: {
    handleLoginEvent(data) {
      this.profile = data.profile;
    },
    setShowTechnicalDetails(show) {
      this.showTechnicalDetails = show;
      this.$gtm.trackEvent({ action: 'ShowTechnicalDetails', category: 'UserProfile', label: 'Toggle Show Technical Details', value: show });

      this.$auth.segmentEventTracking('UserProfile', {
        action: 'ShowTechnicalDetails',
        label: 'ToggleShowTechnicalDetails',
        value: show,
      })
    },
  },
  computed: {
    technicalDetailsButtonLabel() {
      return this.showTechnicalDetails ? 'Hide Technical Details' : 'Show Technical Details';
    },
  },
};
</script>
